var map = {
	"./business board-no-text.svg": "28e6",
	"./course data-no-text.svg": "fd21",
	"./golfoffice-no-text.svg": "9824",
	"./oncourse-no-text.svg": "2630",
	"./onscreen-no-text.svg": "1282",
	"./onservice-no-text.svg": "7a0e",
	"./ontag-no-text.svg": "8d8b",
	"./to do-no-text.svg": "2c87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4057";